import { type WundercomMessage } from '@alto/scriptdash/alto/customer_support/types/v1/wundercom_message';

export const chatbotMessage = 'CHATBOT_LOADING_MESSAGE';

export const getChatbotLoadingMessage = (): WundercomMessage => {
  const date = new Date();
  return {
    id: date.valueOf(),
    classified_intent: null,
    user_id: null,
    admin_user_id: null,
    body: chatbotMessage,
    read_at: date.toISOString(),
    created_at: date.toISOString(),
    updated_at: date.toISOString(),
    support_case_id: null,
    admin_user_name: null,
    suggested_responses: null,
    is_support_chatbot: true,
    title: null,
  };
};

export const getIsInternalURL = (url: string): boolean => {
  // generic urls used to route within the app start with followings as an example:
  // 'https://app.alto.com', 'https://app.stg.alto.com', 'https://app.alto.local.alto.com', or 'https://app-sandbox-name.dev.alto.com'
  const genericURLRegExp = new RegExp('^(http|https)://app[a-z.-]{1,256}alto\\.com', 'i');

  // internal urls starts either with a generic app prefix or a deeplinking prefix
  return genericURLRegExp.test(url) || url.startsWith('https://m.alto.com') || url.startsWith('altopharmacy://');
};
